<template>
  <div id="app">
    <head-Back title="分享"></head-Back>
    <div class="page"></div>

     <div id="foot" class="foot" @click="toLogin">
      <button>立即免费开通使用</button>
    </div>

  </div>
</template>
<script>
import headBack from "../../../components/common/head-back";
import util from "@/utils/util";
import tips from "@/estoast";
import store from "@/store";
import wxapi from "../../../utils/wxapi";
import { mapGetters } from "vuex";
import * as types from "@/store/types";




export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      channelId:null,
    };
  },
  mounted(){

    this.$point.init(new Date());
    store.dispatch('hideLoading');

    var channelId = this.$route.params.channelId;
    console.log('sharchannelIdeid:'+channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    store.commit(types.SET_CHANNEL, channelId);


  },
  methods:{
     toLogin:function(){
        this.$router.push({name:"login",params:{channelId:this.channelId}});
     },
     shareWx:function(){

     }
  },
  components: {
    headBack
  },
   computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 3394px;
  background: url("../../../assets/img/share-back@2x.png");
  background-size: cover;
  white-space: nowrap;
  overflow: hidden;
}
.foot {
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  height: 136px;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 130, 223, 1) 0%,
    rgba(255, 75, 168, 1) 100%
  );
	padding: 28px 50px;
}
.foot {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 998;
}
.foot button {
  width: 652px;
  height: 80px;
  background: linear-gradient(
    90deg,
    rgba(114, 154, 255, 1) 0%,
    rgba(28, 97, 235, 1) 100%
  );
  border-radius: 10px;
	font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 80px;
	border: none;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/page/channel/channel.vue